type QueryValue = string | number | boolean | null | undefined;

/**
 * Builds a short manage URL for a landing page.
 *
 * @param slug - The page slug
 * @param options - Optional subpage query parameter
 * @returns A short manage URL for the landing page builder
 */
export function buildLandingPageManagePath(
  slug: string,
  options?: {
    subpage?: string | null;
  }
): string {
  const params = new URLSearchParams();

  if (options?.subpage) {
    params.set("subpage", options.subpage);
  }

  const query = params.toString();
  return `/${slug}/manage${query ? `?${query}` : ""}`;
}

/**
 * Builds a short settings URL for a landing page.
 *
 * @param slug - The page slug
 * @param options - Optional tab and additional query parameters
 * @returns A short settings URL for the landing page builder
 */
export function buildLandingPageSettingsPath(
  slug: string,
  options?: {
    tab?: string | null;
    query?: Record<string, QueryValue>;
  }
): string {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(options?.query ?? {})) {
    if (value === undefined || value === null) {
      continue;
    }

    params.set(key, String(value));
  }

  const basePath = options?.tab ? `/${slug}/manage/settings/${options.tab}` : `/${slug}/manage/settings`;
  const query = params.toString();

  return `${basePath}${query ? `?${query}` : ""}`;
}
